module.exports = __webpack_public_path__ + "static/img/avatar-8.bc11bfd1.jpg";